import * as React from 'react';

const MlpSportsSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
        <path
            clipRule="evenodd"
            d="M14 21a3 3 0 00-3 3v3.97l-.005-.146A3 3 0 005 28l.001 3H4l-.176.005a3 3 0 000 5.99L4 37h1.001L5 40a3 3 0 006 .03V44a3 3 0 106 0l.001-7h14L31 44a3 3 0 106 0l.001-3.971.004.147A3 3 0 0043 40v-3h1a3 3 0 00.176-5.995L44 31h-1v-3a3 3 0 00-6-.03V24a3 3 0 10-6 0l.001 7h-14L17 24a3 3 0 00-3-3z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5 30.98V37M43 30.98V37M17 30.98V37M31 30.98V37M11 28v12M37 37v3M37 28v3M10.5 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM31.059 22.905a10.984 10.984 0 01-8.418-6.026 7.986 7.986 0 004.443-5.834 7.99 7.99 0 00-2.179-7.003 10.984 10.984 0 019.505-2.875 10.984 10.984 0 017.95 5.953 7.985 7.985 0 00-4.444 5.835 7.99 7.99 0 002.179 7.003 11.056 11.056 0 01-3.511 2.258m.159-.066a10.991 10.991 0 006.59-8.24c1.055-5.983-2.94-11.688-8.923-12.743-5.983-1.055-11.688 2.94-12.743 8.923-1.055 5.983 2.94 11.688 8.923 12.743.155.027.31.051.463.072l5.69-.755z"
            stroke="#1D0A32"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

MlpSportsSvg.displayName = 'MlpSportsSvg';
export default MlpSportsSvg;
